<template>
  <FocusLock class="confirmedDialog">
    <v-btn
      v-if="!dataDialog.hideCloseIcon"
      icon
      class="dialog_closeIcon"
      tabindex="-1"
      @click="clickBtnCancel"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <v-card v-if="!dataDialog.full" class="confirmedDialog_card">
      <v-card-title v-if="dataDialog.title" class="confirmedDialog_title">
        <section>{{ dataDialog.title }}</section>
        <section v-if="dataDialog.code" class="confirmedDialog_title--code">
          Code : {{ dataDialog.code }}
        </section>
      </v-card-title>
      <v-card-text class="confirmedDialog_text">
        <div v-html="dataDialog.content" />
      </v-card-text>
      <v-card-actions
        v-if="dataDialog.cancel || dataDialog.ok || dataDialog.close"
        class="confirmedDialog_actions"
      >
        <v-btn
          v-if="dataDialog.cancel"
          outlined
          rounded
          large
          width="112"
          color="primary"
          @click="clickBtnCancel"
        >
          {{ dataDialog.textCancel }}
        </v-btn>
        <v-btn
          v-if="dataDialog.ok"
          class="confirmedDialog_btn-ok"
          depressed
          width="112"
          color="primary"
          :loading="loading"
          @click="clickBtnOK"
        >
          {{ dataDialog.textOK }}
        </v-btn>
        <v-btn
          v-if="dataDialog.close"
          outlined
          width="112"
          color="primary"
          @click="clickBtnCancel"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </FocusLock>
</template>
<script>
import Lock from 'vue-focus-lock/src/Lock.vue';

export default {
  name: 'ConfirmedDialogTemplate',
  components: {
    FocusLock: Lock,
  },
  props: { dataDialog: { type: Object, default: () => ({}) } },
  data: () => ({
    loading: false,
  }),
  mounted() {},
  methods: {
    clickBtnCancel() {
      if (typeof this.dataDialog.eventReturnData === 'function') {
        this.dataDialog.eventReturnData(false);
      }
      this.$emit('close');
    },
    clickBtnOK() {
      if (typeof this.dataDialog.eventReturnData === 'function') {
        this.dataDialog.eventReturnData(true);
      }
      if (this.dataDialog.loading) {
        this.loading = true;
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss">
.confirmedDialog {
  & .dialog_closeIcon {
    right: 3px;
    top: 3px;
  }
  &_btn-ok {
    padding: 4.6px 49px 8.4px;
    border-radius: 5px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    background-color: #0075c2;
    .v-btn__content {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
    }
  }
  .primary {
    background-color: var(--v-primary-base) !important;
    border-color: var(--v-primary-base) !important;
  }
  .secondary {
    background-color: var(--v-secondary-base) !important;
    border-color: var(--v-secondary-base) !important;
  }
  .error {
    background-color: var(--v-error-base) !important;
    border-color: var(--v-error-base) !important;
  }
  &_card {
    min-height: 241px;
  }
  &_title {
    &.v-card__title {
      justify-content: center;
      flex-direction: column;
      padding: 0;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      color: var(--text-color);
      border-bottom: none;
      margin-bottom: 30px;
      min-height: 0;
      line-height: 27px;
    }
    &--code {
      display: block;
      line-height: 1;
      font-size: 14px;
      font-weight: normal;
      letter-spacing: normal;
    }
  }
  &_text.v-card__text {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    text-align: center;
    color: var(--text-color);
    font-weight: 500;
    margin-bottom: 30px;
    body .v-card & {
      padding: 0 30px;
    }
  }
  &_actions.v-card__actions {
    justify-content: center;
    padding: 0;
    align-items: center;
    display: flex;
    margin-bottom: 30px;
  }
}
</style>
